export const USER_INFO_QUERY_KEY = 'userInfo';

export const PROFILE_QUERY_KEY = 'profile-info';

export const PROFILE_IMAGE_MUTATION_KEY = ['profile', 'saveProfileImage'] as const;
